import { gql } from '@apollo/client';
import { SUBREGION_CARRIER_FIELDS } from '@/graphql/queries/subregion_carrier_mappings';
import { SUBREGION_FIELDS } from '@/graphql/queries/subregions';

export const QUERY_CLIENTS = gql`
    query GetClientsByRole {
        carriers: clients(
            where: { user: { roles: { _has_key: "CARRIER" } }, deactivated: { _eq: false }, approved: { _eq: true } }
            order_by: { business_name: asc_nulls_last }
        ) {
            client_id
            business_name
            supply_chain_legs
            user {
                user_id
                roles
            }
            locations {
                location_id
                location_name
                business_address
                business_unit
                business_city
                business_state
                business_zip
            }
        }
        mm_carriers: clients(
            where: {
                user: { roles: { _has_key: "MIDDLE_MILE_CARRIER" } }
                deactivated: { _eq: false }
                approved: { _eq: true }
            }
            order_by: { business_name: asc_nulls_last }
        ) {
            client_id
            business_name
            supply_chain_legs
            user {
                user_id
                roles
            }
        }
    }
`;

export const QUERY_DELIVERY_PROFILES = gql`
    query GetDeliveryProfiles($where: delivery_profiles_bool_exp!) {
        results: delivery_profiles(where: $where, order_by: { name: asc_nulls_last }) {
            delivery_profile_id
            name
            organization_id
        }
    }
`;

export const GET_DELIVERY_PROFILE = gql`
    ${SUBREGION_FIELDS}
    ${SUBREGION_CARRIER_FIELDS}
    query GetDeliveryProfile($delivery_profile_id: uuid!) {
        result: delivery_profiles_by_pk(delivery_profile_id: $delivery_profile_id) {
            delivery_profile_id
            name
            organization_id
            subregions {
                ...SubregionFields
                carriers(order_by: { is_primary: asc_nulls_last }) {
                    ...SubregionCarrierFields
                }
            }
        }
    }
`;

export const QUERY_DELIVERY_PROFILE_ASSIGNMENTS = gql`
    query GetDeliveryProfileAssignments($where: delivery_profile_assignments_bool_exp!) {
        results: delivery_profile_assignments(where: $where) {
            auto_assign_id
            delivery_profile_id
            shipper_id
            zip_type
            order_type
        }
    }
`;

export const APPLY_DELIVERY_PROFILE_ASSIGNMENTS = gql`
    mutation ApplyDeliveryProfileAssignments($assignments: [delivery_profile_assignments_insert_input!]!) {
        result: insert_delivery_profile_assignments(
            objects: $assignments
            on_conflict: {
                constraint: unique_delivery_profile_assignments
                update_columns: [delivery_profile_id, zip_type]
            }
        ) {
            returning {
                auto_assign_id
                delivery_profile_id
                shipper_id
                zip_type
                order_type
            }
        }
    }
`;

export const UPSERT_DELIVERY_PROFILE = gql`
    mutation UpsertDeliveryProfile($delivery_profile: delivery_profiles_insert_input!) {
        result: insert_delivery_profiles_one(
            object: $delivery_profile
            on_conflict: { constraint: delivery_profiles_pkey, update_columns: [name] }
        ) {
            delivery_profile_id
            name
            organization_id
        }
    }
`;

export const CREATE_SUBREGION = gql`
    ${SUBREGION_FIELDS}
    ${SUBREGION_CARRIER_FIELDS}
    mutation CreateSubregion($subregion: subregions_insert_input!) {
        result: insert_subregions_one(object: $subregion) {
            ...SubregionFields
            carriers {
                ...SubregionCarrierFields
            }
        }
    }
`;

export const UPSERT_CARRIER_MAPPING = gql`
    ${SUBREGION_CARRIER_FIELDS}
    mutation UpsertCarrierMapping($mapping: subregion_carrier_mappings_insert_input!) {
        result: insert_subregion_carrier_mappings_one(
            object: $mapping
            on_conflict: {
                constraint: subregion_carrier_mappings_pkey
                update_columns: [
                    carrier_id
                    middle_mile_carrier_id
                    warehouse_carrier_id
                    warehouse_id
                    is_direct
                    site_code
                    site_contact_name
                    site_contact_email
                    site_contact_phone
                ]
            }
        ) {
            ...SubregionCarrierFields
        }
    }
`;

export const UPLOAD_SUBREGIONS = gql`
    ${SUBREGION_FIELDS}
    ${SUBREGION_CARRIER_FIELDS}
    mutation UploadSubregions($subregions: [subregions_insert_input!] = [], $to_delete: [uuid!] = []) {
        deleted: delete_subregions(where: { subregion_id: { _in: $to_delete } }) {
            affected_rows
            returning {
                subregion_id
            }
        }
        created: insert_subregions(objects: $subregions) {
            returning {
                ...SubregionFields
                carriers {
                    ...SubregionCarrierFields
                }
            }
        }
    }
`;
